import { deepEqual } from 'fast-equals';

import type { SortOptionProps } from 'components/search/Sort';
import { sortStringToObject } from 'helpers/SearchUtils';

/**
 * Given a list of sort options, return the option which matches
 * the passed in criteria.
 * @param  {object[]} sortOptions array of sort options
 * @param  {object} criteria      object of sort criteria
 * @return {object}               matching sort option or undefined
 */
export const getSelectedSortValue = (sortOptions: SortOptionProps[], criteria: SortOptionProps) =>
  sortOptions.find(({ value }) => deepEqual(sortStringToObject(value), criteria)) || sortOptions[0];
